// src/features/auth/register/components/TextField.jsx

import styles from "../Register.module.css";

const TextField = ({ label, icon, error, ...props }) => {
  return (
    <div className={styles.field}>
      <label className={styles.label}>{label}</label>

      <div className={styles.inputWrap}>
        <span className={styles.iconLeft}>{icon}</span>
        <input
          className={`${styles.input} ${error ? styles.inputError : ""}`}
          {...props}
        />
      </div>

      {error && <span className={styles.fieldError}>{error}</span>}
    </div>
  );
};

export default TextField;
